module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_3.0c45a279.png";